//Send customer interests to CF and Voyado, timer to avoid too many requests

let timer;

document.addEventListener("interests-updated", (event) => {
  eventHandlerInterest(event.detail.interests, event.detail.id);
});

document.addEventListener("sizes-updated", (event) => {
  eventHandlerSize(event.detail.sizeTitle, event.detail.sizes, event.detail.customerId);
});

function eventHandlerInterest(interests, id) {
  clearTimeout(timer); // Reset the timer
  timer = setTimeout(function () {
    CF.customerReady(function () {
      CF.customer.update({
        preference_interests: interests,
      });
    });
   
    if (id) {
      fetch(`${shopUrl}/apps/jl-api/frontend/klaviyo/profile`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            preferredCollections: interests,
          },
        }),
      })
        .then((response) => {
          //return response.json();
        })
        .then((response) => {
          //console.log(response);
        });
    }
  }, 1000);
}

function eventHandlerSize(title, sizes, customerId) {
  clearTimeout(timer); // Reset the timer
  timer = setTimeout(function () {
    CF.customerReady(function () {
      CF.customer.update({
        [title]: sizes,
      });
    });

    const data = {}

    if (customerId) {
      if(title === "preference_size_tailoring"){
        data["preferenceSizeTailoring"] = sizes;
      }
      else if(title === "preference_size_shoes"){
        data["preferenceSizeShoes"] = sizes;
      }
      else if(title === "preference_size_bottoms"){
        data["preferenceSizeBottoms"] = sizes;
      }
      else if(title === "preference_size_tops"){
        data['preferenceSizeTops'] = sizes;
      }

      fetch(`${shopUrl}/apps/jl-api/frontend/klaviyo/profile`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data,
        }),
      })
        .then((response) => {
          //return response.json();
        })
        .then((response) => {
          //console.log(response);
        });
    }

  }, 1000);
}
